<template>
  <div class="container flex justify-center my-24">
    <div class="w-full sm:w-3/4 lg:w-1/2 xl:w-2/5">
      <header class="relative flex justify-center mb-5">
        <div class="h3 text-secondary">
          {{ comments.length }} {{ comments.length === 1 ? 'Reactie' : 'Reacties' }}
        </div>
        <button class="absolute right-0 bottom-0 block btn btn-secondary">
          Reageer
        </button>
      </header>

      <main id="comments-container">
        <section v-for="comment in comments" :key="comment.title" class="comment">
          <div class="px-8 md:px-16">
            <header class="mb-4">
              <span class="font-bold">{{ comment.title }} </span>
              <time :datetime="comment.created_at">{{ $moment(comment.created_at).format('LLL') }}</time>
            </header>
            <span class="prose" v-html="comment.reactie"/>
            <footer class="text-right text-xs text-secondary">
              <nuxt-link to="/" class="link-secondary">
                Deel
              </nuxt-link>
              <font-awesome-icon :icon="['fas', 'share-alt']" class="ml-2"/>
            </footer>
          </div>
        </section>
        <form class="add-comment" @submit.prevent="submit">
          <text-field id="first-name" v-model="form.title" placeholder="Je naam">
            Je naam:
          </text-field>
          <editor-text-field ref="editor" v-model="form.reactie">
            Jouw reactie:
          </editor-text-field>
          <footer class="flex justify-end">
            <button type="submit" class="block btn btn-secondary">
              Reageer
            </button>
          </footer>
        </form>

        <img src="~/assets/img/shapes/circle-drk-red-2.svg" class="circle--left">
        <img src="~/assets/img/shapes/circle-light-red.svg" class="circle--right">
      </main>
    </div>
  </div>
</template>

<script>
import TextField from '~/components/forms/TextField';
import createReactie from '~/graphql/mutations/createReactie';
import EditorTextField from '~/components/forms/EditorTextField';

export default {
  components: {EditorTextField, TextField},
  props: {
    comments: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    form: {
      title: null,
      reactie: null,
    },
  }),
  methods: {
    async submit() {
      const payload = {...this.form, blog: this.$route.params.slug};
      try {
        const {data} = await this.$apollo.mutate({mutation: createReactie, variables: payload});
        this.comments.push(data.createReactie);
        this.form = {
          title: null,
          reactie: null,
        };
        this.$refs.editor.editor.clearContent();
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#comments-container {
  @apply relative z-20 h-full flex flex-col bg-white border border-primary-light pt-8 pb-4;
  box-shadow: 0 3px 25px 0 rgba(0, 0, 0, 0.18);
  @screen md {
    @apply pt-16;
  }
  .comment {
    @apply bg-white border-b-2 border-primary-lighter pb-2 pt-5;
  }

  .add-comment {
    @apply px-8 pt-8;
    @screen md {
      @apply px-16;
    }
    &--style {
      @apply flex shadow-md;
      height: 30px;

      &--icon {
        @apply flex items-center px-3 text-sm h-full transition duration-300;
        &:nth-of-type(2) {
          @apply border-l border-r border-primary-medium;
        }

        &:hover {
          @apply text-white bg-secondary-lightest;
        }
      }
    }
  }
}

.circle {
  &--left {
    @apply absolute;
    z-index: -1;
    left: -55%;
    top: 10%;
  }

  &--right {
    @apply absolute opacity-25;
    z-index: -1;
    top: 35%;
    right: -25%;
    height: 300px;
  }
}
</style>
